// extracted by mini-css-extract-plugin
module.exports = {"bodyTitle":"NolBottomSheet_bodyTitle__12eIJ","bodyDescription":"NolBottomSheet_bodyDescription__13_XS","bodyContainer":"NolBottomSheet_bodyContainer__3faaT"};